module.exports = __webpack_public_path__ + "media/images/emblems/Rorbas-blazon-3b62d0f561cb7d8418a134cb96be206e.svg";